export enum ConfiguratorType {
  LabWater = 'labwater',
  MilliQSq = 'milliqsq',
  Milliplex = 'milliplex',
}

export enum ConfiguratorProperties {
  ConfigurationNameMaxLength = 50,
  MessageToSpecialistMaxLength = 500,
}

export enum ConfiguratorGaEventName {
  Lab_Water_Configurator_Interaction = 'lab_water_configurator_interaction',
  Product_Info_Interaction = 'product_info_interaction',
  Modulis_Configurator_Interaction = 'modulis_configurator_interaction',
}
